import { kml } from "@tmcw/togeojson"
import * as turf from "@turf/turf"
import type { FeatureCollection, Geometry } from "geojson"
import shp from "shpjs"

import { convertGeometryTo2D } from "./utils"

// NOTE: Want to strip bbox properties from Geometry objects to avoid sending those along in the payload
// TODO: this could probably be elaborated on to support a variety of other geospatial formats, coordinate systems,
//   other shapefile sidecar files like .prj, .dbf, .shx

// NOTE: it is expected that the geojson file is already in Wgs84
export async function loadGeometriesFromGeoJsonFile(file: File): Promise<Geometry[]> {
	const text = await file.text()
	const featureCollection = JSON.parse(text) as FeatureCollection

	turf.geomEach(featureCollection, (geom) => {
		delete geom.bbox
		convertGeometryTo2D(geom)
	})

	return featureCollection.features.map((f) => f.geometry)
}

// NOTE: file should be a .zip containing a shapefile directory
export async function loadGeometriesFromShapeFile(file: File): Promise<Geometry[]> {
	const buffer = await file.arrayBuffer()
	const featureCollection = (await shp(buffer)) as FeatureCollection

	turf.geomEach(featureCollection, (geom) => {
		delete geom.bbox
		convertGeometryTo2D(geom)
	})

	return featureCollection.features.map((f) => f.geometry)
}

export async function loadGeometriesFromKmlFile(file: File): Promise<Geometry[]> {
	const parser = new DOMParser()
	const text = await file.text()
	const xml = parser.parseFromString(text, "text/xml")
	const featureCollection = kml(xml) // returns a valid GeoJSON FeatureCollection

	turf.geomEach(featureCollection, (geom) => {
		if (!geom) return
		delete geom.bbox
		convertGeometryTo2D(geom)
	})

	return featureCollection.features.filter((feature) => feature.geometry !== null).map((f) => f.geometry!)
}
